(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const intro = document.getElementById('splash-intro');
  if (!intro) return;

  const wasShown = sessionStorage.getItem('intro-shown');
  
  if (wasShown) {
    intro.classList.add('splash-hidden');
    intro.style.display = 'none';
    return;
  }

  sessionStorage.setItem('intro-shown', 'true');
  document.body.classList.add('splash-active', 'splash-hide-header');
  intro.focus();

  const video = intro.querySelector('.intro_video');
  if (video) {
    video.play().catch(function(){});
  }

  let virtualScrollY = 0;
  let isHidden = false;
  
  // Different scroll thresholds for desktop and mobile
  const isMobile = window.innerWidth <= 768;
  const scrollThreshold = isMobile ? 75 : 300;

  const hideSplash = function() {
    if (isHidden) return;
    isHidden = true;
    intro.classList.add('splash-hidden');
    window.scrollTo(0, 0);
    setTimeout(function() {
      document.body.classList.remove('splash-active', 'splash-hide-header');
      window.scrollTo(0, 0);
    }, 400);
    window.removeEventListener('wheel', onWheel, { passive: false });
    intro.removeEventListener('touchstart', onTouchStart, { passive: true });
    intro.removeEventListener('touchmove', onTouchMove, { passive: false });
  };

  const onWheel = function(e) {
    if (isHidden) return;
    e.preventDefault();
    virtualScrollY += Math.abs(e.deltaY);
    if (virtualScrollY > scrollThreshold) {
      hideSplash();
    }
  };

  let touchStartY = null;
  const onTouchStart = function(e) {
    if (isHidden) return;
    if (e.touches && e.touches.length === 1) {
      touchStartY = e.touches[0].clientY;
    }
  };

  const onTouchMove = function(e) {
    if (isHidden || touchStartY === null) return;
    e.preventDefault();
    const touchCurrentY = e.touches[0].clientY;
    const deltaY = Math.abs(touchStartY - touchCurrentY);
    virtualScrollY += deltaY * 0.5;
    touchStartY = touchCurrentY;
    
    if (virtualScrollY > scrollThreshold) {
      hideSplash();
    }
  };
  
  window.addEventListener('wheel', onWheel, { passive: false });
  intro.addEventListener('touchstart', onTouchStart, { passive: true });
  intro.addEventListener('touchmove', onTouchMove, { passive: false });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
